import React, { useEffect, useState } from 'react';
import './index.css';
import { convertTicketFormat, formatEventDateRange, getDayFromDate, moneyRoundOff } from '../../../../../../utils/func';
import { DEFAULT_CURRENCY } from '../../../../../../constants';
import GuestDetailCard from '../DetailCard';
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from "react-icons/io";
import { ErrorMessage } from 'formik';

const TicketGuestDetail = ({ item, guestDetail, values, errors, handlePreCheckout, setErrorEvent, fieldRefs, openErrorEvent, checkForCheckoutPage, eventId, eventIndex, setFieldError, eventRequirements, ticketIndex, guestQuantity, setFieldValue }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [showGuestError, setShowGuestError] = useState("Please select only 2 active guest")

    useEffect(() => {
        if (openErrorEvent === eventIndex) {
            setIsOpen(true)
        }
    }, [openErrorEvent])

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
        setErrorEvent(null)
    };

    const handleGetDaysWithFormat = (day, validFrom) => {
        return day === "singleday"
            ? getDayFromDate(validFrom)
            : convertTicketFormat(day);
    };

    return (
        <div className="ticket-guest-detail" >
            {/* <div className="dropdown-header" onClick={toggleDropdown}> */}
            <div className="dropdown-header" >
                <div className="item-details">
                    <p>{`${item?.event_event?.tournament?.official_name} ${item?.event_event?.season}`} -
                        {formatEventDateRange(item?.event_event?.tournament?.date_start, item?.event_event?.tournament?.date_stop)}</p>
                    <p> {`${item?.category_name}`} -
                        {handleGetDaysWithFormat(item?.eventdays, item?.ticket_validfrom)}
                    </p>
                    <p>{item?.event_event?.venue?.official_name}</p>
                    <p>{item?.quantity} × {`${DEFAULT_CURRENCY} ${moneyRoundOff(
                        item.net_rate_inr
                    )}`}</p>
                    {
                        errors?.BookingData?.[eventIndex]?.tickets?.[ticketIndex]?.ticketError &&
                        <span className="error-message"  >{errors?.BookingData?.[eventIndex]?.tickets?.[ticketIndex]?.ticketError}</span>
                    }
                </div>
                {/* <span >
                    {isOpen ? <IoIosArrowDropupCircle /> : <IoIosArrowDropdownCircle />}
                </span> */}
            </div>
            <div className={`dropdown-content ${isOpen ? 'open' : ''}`} style={{ height: isOpen ? "auto" : "0", overflow: isOpen ? "visible" : "hidden" }} >
                {
                    Array.from({ length: guestDetail?.length })?.map((_, index) => {
                        return (
                            <GuestDetailCard handlePreCheckout={handlePreCheckout} fieldRefs={fieldRefs} checkForCheckoutPage={checkForCheckoutPage} setFieldError={setFieldError} eventId={eventId} eventRequirements={eventRequirements} values={values} setFieldValue={setFieldValue} guestNumber={index} guestRequired={guestDetail?.[index]} key={index} eventIndex={eventIndex} ticketIndex={ticketIndex} guestIndex={index} showGuestError={showGuestError} setShowGuestError={setShowGuestError} />
                        )
                    })
                }
            </div>
        </div>
    );
};

export default TicketGuestDetail;
